import { authGet } from "@api/auth/auth";
import { AUTH_URL } from "@constants";
import { AuthProvider } from "@types";

export const fetchAuthConfig = (
  authProviderId: string
): Promise<AuthProvider> => {
  return authGet<AuthProvider>(`${AUTH_URL}/config/${authProviderId}`);
};
